import { handleDeleteReply, publishReplyComment } from "@/apis/dp/service";
import IntlDialog from "@/components/intlMui/dialog";
import UKToast from "@/components/UKToast";
import { useTranslation } from "@/i18n/client";
import { callAfterLogin, JDILogin } from "@/lib/jdiClientUtils";
import { sendClickTrack } from "@/tracks/25217";
import { avatarFn } from "@/utils";
import Avatar from "@mui/material/Avatar";
import cn from "clsx";
import { useEffect, useRef, useState } from "react";
import { SubmitButton } from "../intlMui/button";
import CustomTextarea from "./customTextArea";
import { sendClickTrack as reviewDetailSendClickTrack } from '@/tracks/25347';
import TranslatePage from '@/components/translate';

const ReplyItem = ({
  isOpenDetailDialog = false,
  isCustomer = false,
  onReplyChange,
  pageType,
  ...rest
}: any) => {
  const { t } = useTranslation();
  const [isShowReply, setIsShowReply] = useState<boolean>(false);
  const [replyContent, setReplyContent] = useState<string>('');
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const currentRef = useRef<HTMLDivElement>(null);

  const {
    item: {
      userNickName,
      userImage,
      content,
      commentDate,
      parentReplyId,
      id: targetReplyId,
      replyNickname,
      canDelete,
      tag,
    },
    extraData: { commentId, skuId } = {},
  } = rest || {};
  const [translateContent, setTranslateContent] = useState(content || '');
  const onTextareaChange = (value: string) => {
    if (/^[\s\n\r]*$/.test(value)) {
      setReplyContent('');
    } else {
      setReplyContent(value);
    }
  };
  const onSecondaryReply = () => {
    sendClickTrack.Productdetail_ReviewsFloor_CommentBtn_Click();
    if (!isOpenDetailDialog) {
      setIsShowReply((preState) => !preState);
    }
  };
  const onReplyDelete = async () => {
    const res = await handleDeleteReply({ replyId: targetReplyId, skuId });
    if (res?.data?.deleteResult) {
      setIsDelete(true);
      setDeleteOpen(false); // 删除成功后关闭弹窗
      // 通知父组件删除成功，直接传递要删除的ID
      onReplyChange?.(targetReplyId);
      UKToast.show({
        icon: 'success',
        content: t('common.message.deleteSuccessful'),
      });
    }
  };

  const onSecondaryReplySubmit = async () => {
    const parentContainer = currentRef?.current?.closest('.MuiDialog-container');
    if (parentContainer) {
      parentContainer.removeAttribute('tabindex');
    }
    callAfterLogin(async () => {
      const userInfo = await JDILogin.getInstance().getUserInfo();
      if (userInfo.isLoggedIn) {
        const res = await publishReplyComment({
          targetReplyId,
          parentReplyId,
          anonymousFlag: false,
          commentId,
          content: replyContent,
        });

        const { saveResult, ...dataRest } = res?.data || {};
        if (saveResult) {
          onReplyChange?.({
            ...dataRest,
            replyNickname: userNickName,
            content: replyContent,
            canDelete: true,
          });
          setReplyContent('');
          setIsShowReply(false);
        } else {
          UKToast.show({
            icon: 'error',
            content: res.msg,
          });
        }
      }
    });
  };
  // if (isDelete) {
  //   return null;
  // }
  const onTranslationTrack = (isclick: string) => {
    reviewDetailSendClickTrack.Evaluate_CommentDetail_TranslateBtn({
      mainskuid: skuId,
      btnStatus: isclick,
      commentId: commentId,
      index: 1,
      skuid: skuId,
    });
  };

  return (
    <div className='child depth-2' >
      <div className='child-header'>
        <div className='avatar' style={{ display: 'flex', alignItems: 'center' }}>
          {/* <CDNImage src={userImage} width={20} height={20} alt=""/> */}
          <Avatar
            sizes='20'
            src={avatarFn(userImage) || ''}
            alt=''
            slotProps={{
              img: {
                loading: 'lazy',
              },
            }}
            sx={{
              width: '20px',
              height: '20px',
              bgcolor: '#E1E3E6',
              '& .MuiSvgIcon-root': {
                width: '100%',
                height: '100%',
                fill: '#F0F1F2',
              },
            }}
          />
          <span style={{ marginLeft: '6px' }}>{userNickName}</span>
          {tag && (
            <span
              className={cn(
                'tag',
                tag == 'From Joybuy' && 'tagJoy',
                tag == 'Author' && 'tagAuthor',
              )}
            >
              {tag}
            </span>
          )}
        </div>
        <div className='date-time'>{commentDate}</div>
      </div>
      <div className='content'>
        <div className='static-text'>
          {replyNickname && (
            <span className='replyNickName'>
              {t('common.btnText.reply')}{' '}
              {replyNickname.length >= 20 ? `${replyNickname?.slice(0, 19)}...` : replyNickname}
            </span>
          )}
          <span>{translateContent}</span>
        </div>
      </div>
      <div className='reply-btn-box '>
        {!isCustomer && (
          <div className='reply-btn'>
            {canDelete && (
              <span onClick={() => setDeleteOpen(true)}>{t('common.btnText.delete')}</span>
            )}
            <span onClick={onSecondaryReply}>{t('common.btnText.reply')}</span>
          </div>
        )}
        {translateContent && (
          <TranslatePage
            content={translateContent}
            setTranslateContent={setTranslateContent}
            onTranslationTrack={onTranslationTrack} 
          />
        )}
      </div>
      {isShowReply && (
        <div className='comment-reply'>
          <CustomTextarea
            onChange={onTextareaChange}
            placeholder={t('review.commentArea')}
          ></CustomTextarea>
          <p className='opt' ref={currentRef}>
            <SubmitButton onClick={() => replyContent && onSecondaryReplySubmit()}>
              {t('common.btnText.submit')}
            </SubmitButton>
          </p>
        </div>
      )}
      <IntlDialog
        onClose={() => setDeleteOpen(false)}
        aria-labelledby='customized-dialog-title'
        open={deleteOpen}
        title={t('review.deleteTitle')}
        content={
          <>
            <div className='report-reason-wrapper'>{t('review.deleteConfirm')}</div>
          </>
        }
        onSubmit={onReplyDelete}
        onCancel={() => setDeleteOpen(false)}
      />
    </div>
  );
};
export default function SecondaryReplyList(props: any) {
  const { replyList = [], customReplyList, ...rest } = props;
  const [innerCustomReplyList, setInnerCustomReplyList] = useState<any[]>(customReplyList || []);
  const [deletedIds, setDeletedIds] = useState<Set<string | number>>(new Set());
  
  const onReplyChange = (value: any) => {
    // 如果是删除操作，直接传入要删除的ID
    if (value && (typeof value === 'string' || typeof value === 'number')) {
      setDeletedIds(prev => {
        const newSet = new Set([...prev, value]);
        return newSet;
      });
      return;
    }
    
    // 如果是新增回复，添加到列表开头
    setInnerCustomReplyList([value, ...innerCustomReplyList]);
  };
  useEffect(() => {
    setInnerCustomReplyList(customReplyList || []);
  }, [customReplyList]);
  
  // 过滤掉已删除的回复
  const filteredReplyList = replyList.filter((item: any) => !deletedIds.has(item.id));
  const filteredCustomReplyList = innerCustomReplyList.filter((item: any) => !deletedIds.has(item.id));
  
  return (
    <div className='secondary-reply-list'>
      {/*   {innerCustomReplyList?.map((item: any) => {*/}
      {/*  return <ReplyItem key={item.id} item={item} isCustomer={false}/>;*/}
      {/*})}*/}
      {[...filteredCustomReplyList, ...filteredReplyList].map((item: any, index: number) => {
        return <ReplyItem key={item.id} item={item} onReplyChange={onReplyChange} {...rest} />;
      })}
      {/* {
        !isOpenDetailDialog && (
        )
      } */}
    </div>
  );
}
